<template>
  <v-container fluid class="pa-0">
    <DialogNearestBanks ref="dialogNearestBanks"></DialogNearestBanks>
    <v-layout row fluid>
    <div>
      <searchMask balanceName="Anker" ref="SearchMask1" eventName="OnGetHitListSearch" eventNameSubmit="OnStartSubmit"
                  configName="hitlistankerSearch" tableName=""
                  @collapseEvent="collapseEvent"></searchMask>
    </div>
    <v-flex style="padding: 0px; margin: 0px;">
      <v-card flat style="padding: 0px; margin: 0px;">
        <v-card-text style="padding: 0px; margin: 0px;">
          <FixedTableIE :widthSub="widthSub" :heightSub="38" :heightCRSSub="0" :ankerBank="bankAnchor" ref="sdTable"
                        :currency="currentCurrency"
                        configSuffix="hitlistankerSearch" tableName=""
                        :headerConfigName="'Anker'"
                        :selected="selected"
                        :tableConfig='tableConfig' :tableNotComplete="tableNotComplete"
                        :headers="headers" :items="pgresults" class="colorrows"></FixedTableIE>
          <div v-if="((pgresults === null))"
               class="font-weight-bold bluetext textleft missingDataInPeergroup">{{'TITLE_PEERGROUP_SELECT_FILTERS' |
            translate}}
          </div>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <HitlistCounter></HitlistCounter>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  import SearchMask from './mask/SearchMaskv2'
  import Vue from 'vue'
  import FixedTableIE from './../tables/EasyTableIE'
  import DialogNearestBanks from './dialogs/DialogNearestBanks'
  import HitlistCounter from '../widgets/HitlistCounter'

  export default {
    name: 'Suche.vue',
    components: {HitlistCounter, SearchMask, FixedTableIE, DialogNearestBanks},
    data() {
      return {
        link: '',
        currentItem: null,
        first: true,
        firstOrderBy: '',
        currentCrefoNr: -1,
        myData: null,
        tableNotComplete: false,
        headers: [],
        widthSub: 350,
        pgresults: [],
        currentCurrency: '1',
        bankAnchor: null,
        selected: false,
        headerFields: [{'id': 'companyName', 'type': 'nm', 'orderNr': '0', 'name': 'Name des Unternehmens'}, {
          'id': 'rk',
          'type': 'nm',
          'orderNr': '1',
          'name': 'Rechtskreis'
        }, {'id': 'aa', 'type': 'nm', 'orderNr': '2', 'name': 'Abschlussart'}, {
          'id': 'year',
          'type': 'nm',
          'orderNr': '4',
          'name': 'Jahr'
        }, {
          'id': 'source',
          'type': 'nm',
          'orderNr': '5',
          'name': 'Quelle'
        }],
        idModule: '',
        idModuleItem: '',
        'tableConfig': {
          selection: false,
          isClickable: true,
          header: {
            columnClass: 'verlauf abstandunten04 theme--light blue tableIEPadding1 headcolumn'
          },
          rows: {
            rowClass: 'rowEIE'
          }
        }
      }
    },
    methods: {
      collapseEvent: function (isMini) {
        if (isMini) {
          this.widthSub = 40
        } else {
          this.widthSub = 350
        }
        // console.log('collapseEvent', this.widthSub)
      },
      openTable: function () {
        var cmp = this
        if (this.$refs.sdTable && this.$refs.sdTable.updateData) {
          this.$refs.sdTable.updateHeader(this.headers)
          let orderCellName = null
          if (cmp.first) {
            for (var i = 0;i < this.headers.length; i++) {
              let headItem = this.headers[i]
              if (headItem.meta.id.indexOf('Name') > -1) {
                orderCellName = i + 1
                cmp.first = false
                break;
              }
            }
          }
          this.$refs.sdTable.updateData(cmp.pgresults, true, orderCellName)
        }
      },
      open: function () {
        this.headers = []
        var result = Vue.prototype.$api.prepareWaimeaTable(this.myData.table)
        this.pgresults = result.rows
        this.headers = result.headers
        if (this.myData && this.myData.table && this.myData.table.rows && this.myData.table.rows) {
          Vue.prototype.$eventHub.$emit('hitlistcounter', {
            hits: this.myData.table.rows.length,
            totalHits: this.myData.totalHits,
            totalHitsAppendix: this.myData.totalHitsAppendix
          })
        } else {
          Vue.prototype.$eventHub.$emit('hitlistcounter', {
            hits: -1,
            totalHits: -1,
            totalHitsAppendix: ''
          })
        }
        /*
        var cmp = this
        if (this.$refs.sdTable && this.$refs.sdTable.updateData) {
          this.$nextTick(function () {
            cmp.$refs.sdTable.updateData(cmp.pgresults)
          })
        }
         */
        this.openTable()
      },
      close: function () {
        if (this.$refs.sdTable && this.$refs.sdTable.doDestroyTable) {
          this.$refs.sdTable.doDestroyTable()
        }
      },

      onGetNearestBank: function (data) {
        Vue.prototype.$api.debug('onGetNearestBank', data)
        if (data.table.rows.length < 1) {
          Vue.prototype.$api.debug('Keine Treffer für crefoNr ' + this.currentCrefoNr)
          var balance = {
            aaNr: '0',
            crefoNr: this.currentCrefoNr,
            rkNr: '0',
            source: '0',
            year: '0'
          }
          Vue.prototype.$api.debug('open balance', balance)

          this.$router.push(Vue.prototype.$api.getStructureAnchorUrl(this.idModule, balance))
          return
        }
        Vue.prototype.$api.debug('onGetNearestBank', data.table.rows.length, this.currentItem.meta.balanceAvailable)
        // Kein NachschaltDialog anzeigen wenn kein Abschluss vorhanden also wenn -> this.currentItem.meta.balanceAvailable === false
        if ((data.table.rows.length === 1) || (!this.currentItem.meta.balanceAvailable)) {
          var balance = data.table.rows[0].balance
          Vue.prototype.$api.debug('balance', balance)
          this.$router.push(Vue.prototype.$api.getStructureAnchorUrl(this.idModule, balance))
        } else {
          this.$refs.dialogNearestBanks.show(data)
        }
      },
      onSelectItem: function (item) {
        Vue.prototype.$api.debug('show after dialog for', item)
        this.currentItem = item
        if (item.meta) {
          if (item.meta.balance) {
            this.currentCrefoNr = item.meta.balance.crefoNr
          } else {
            this.currentCrefoNr = item.meta.crefoNr
          }
        }

        var result = Vue.prototype.$api.createSearchDataFromFieldsWithCrefoNr(this, this.headerFields, item.meta.crefoNr)
        Vue.prototype.$api.searchNearestBanks(result.searchData, this.onGetNearestBank, Vue.prototype.$api.onFailure)
      },
      OnGetHitListSearch: function (data) {
        Vue.prototype.$api.debug('OnGetHitListSearch', data)
        this.myData = data
        Vue.prototype.storage.saveState('asLastHitList', data)
        this.open()
      }
    },
    created() {
      Vue.prototype.$eventHub.$on('OnGetHitListSearch', this.OnGetHitListSearch)
      Vue.prototype.$eventHub.$on('ETClickOnRow', this.onSelectItem)
    },
    destroyed() {
      Vue.prototype.$eventHub.$off('OnGetHitListSearch', this.OnGetHitListSearch)
      Vue.prototype.$eventHub.$off('ETClickOnRow', this.onSelectItem)
    },
    mounted() {
      var cmp = this
      this.first = true
      Vue.prototype.$eventHub.$emit('hitlistcounter', {
        hits: -1,
        totalHits: -1,
        totalHitsAppendix: ''
      })
      Vue.prototype.$api.checkCredentials(cmp, function () {
        Vue.prototype.storage.resetPeergroup(Vue.prototype.$api.getModuleId())
        Vue.prototype.storage.resetAnkerbank(Vue.prototype.$api.getModuleId())
        if (cmp.$route.params) {
          cmp.idModule = cmp.$route.params.idModule
          cmp.idModuleItem = cmp.$route.params.idModuleItem
        }
        Vue.prototype.$api.getBreadCrumpModule(cmp.idModule)
        cmp.firstOrderBy = cmp.idModule + 'Name'
        cmp.link = '/di/StructureData/' + cmp.idModule
      })
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/module/Suche.vue